export enum ValueType {
    Absolute,
    Variable,
    Formula,
}
